import Header from "./Header";
import Footer from "./Footer";
import StickyBookBar from "./StickyBookBar";

export const Layout = ({ children }) => (
  <div className="min-h-screen bg-sand flex flex-col">
    <a href="#main" className="skip-link">
      Skip to content
    </a>
    <Header />
    <main id="main" className="flex-1 pb-24 sm:pb-0">
      {children}
    </main>
    <Footer />
    <StickyBookBar />
  </div>
);

export default Layout;
